const measurementId = 'G-CDV1WLDY5Y'

// GA event name -> OpenAI Ads conversion. Data shapes follow the measurement
// pixel docs: registration uses customer_action, subscriptions plan_enrollment.
const adConversions = {
	sign_up: () => ({ event: 'registration_completed', data: { type: 'customer_action' } }),
	purchase: params => ({
		event: 'subscription_created',
		data: { type: 'plan_enrollment', plan_id: params.items?.[0]?.item_name },
		options: params.transaction_id ? { event_id: String(params.transaction_id) } : undefined,
	}),
}

// Reports a conversion to OpenAI Ads. The pixel only exists on production hosts,
// so this is a no-op everywhere else.
function sendAdConversion(name, params) {
	const toConversion = adConversions[name]
	if (!toConversion || typeof window.oaiq !== 'function') return
	// A third-party failure must never interrupt signup or payment redirects
	try {
		const { event, data, options } = toConversion(params)
		window.oaiq('measure', event, data, options)
	} catch (err) {}
}

// Sends an event to GA4 and, for signups and purchases, to OpenAI Ads.
// Safe to call when either tag has not loaded (ad blockers, tests).
export function trackEvent(name, params = {}) {
	if (typeof window.gtag === 'function') window.gtag('event', name, params)
	sendAdConversion(name, params)
}

async function sha256Hex(text) {
	const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(text))
	return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('')
}

// Lets OpenAI Ads match conversions to the ad click when the click ID is gone.
// Only SHA-256 hashes leave the browser, normalized the way the pixel docs ask.
async function identifyAdUser(userId, email) {
	if (typeof window.oaiq !== 'function' || !window.crypto?.subtle) return
	try {
		const user = { external_id_sha256: await sha256Hex(String(userId).trim()) }
		if (email) user.email_sha256 = await sha256Hex(email.trim().toLowerCase())
		window.oaiq('init', { user })
	} catch (err) {}
}

// Ties this browser's sessions to the account so the landing -> signup -> paid
// journey is one user in GA4 even across devices.
export function setAnalyticsUser(userId, email) {
	if (!userId) return
	if (typeof window.gtag === 'function') {
		window.gtag('config', measurementId, { user_id: String(userId), send_page_view: false })
	}
	identifyAdUser(userId, email)
}
